import React, { useEffect } from "react";
import { isUserAuthenticated } from "./WorkerService";
import logo from "../assets/images/logo.png";
import { useUserContext } from "./UserContext";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";

export interface IHeaderProps {
    title?: string;
}

const DataCapture: React.FC<IHeaderProps> = (props) => {
    const usercontext = useUserContext();

    useEffect(() => {
        const checkIfloggedIn = async () => {
            if(!await isUserAuthenticated()){
                window.location.href = "/login";
            }
        }
        checkIfloggedIn();
    }, [])

    const handleLogout = () => {
        usercontext.logout();
    };

    return (
        <div className="d-flex title">
            <div  style={{width:"auto", alignItems:"center", overflow:"hidden"}}>
                <img src={logo} alt="Logo" height="55px" />
            </div>
            <div className="title-text">{props.title}</div>
            <div>
                <Link to='#'
                    onClick={(e) => {
                        window.location.href = "mailto:Businesssupport@matrixiq.com";
                        e.preventDefault();
                    }}>Contact Us
                </Link>
                <Button style={{width:"90px", marginLeft:".5rem"}} onClick={handleLogout}>Log out</Button>
            </div>
        </div>
    );
}

export default DataCapture;